import styles from './styles.module.scss'

import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';

import { Button, Card } from 'antd';
import { getNavUrl } from '@/utils/navigation';

export const PageFB = () => {
  const history = useHistory();

  const moveToLink = (e: React.MouseEvent) => {
    e.preventDefault()
    history.push(getNavUrl('/event/summer_sale?utm_campaign=summer_sale&utm_source=facebook&utm_medium=cpc'))
  }

  return (
    <>
      <Helmet>
        <title>Facebook</title>
      </Helmet>
      <div className={styles.header}>
        <h2>페이셜북 - 피드</h2>
      </div>
      <div className={styles.body}>
        <div className={styles.content}>
          <Card>
            <div className={styles.colThumbnail}>
              <img className={styles.thumbnail} src="/ga4/feed.jpg"/>
              <p className={styles.author}>Photo by <a target="blank" rel="noopener noreferrer"  href="https://unsplash.com/@lacylucy?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Lucinda Hershberger</a> on <a target="_blank" rel="noopener noreferrer" href="https://unsplash.com/s/photos/strawberry?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Unsplash</a></p>
            </div>
            <div className={styles.colContent}>
              <div className={styles.rowDescription}>
                <p className={styles.title}>딸기는 지금이 제일 맛있어요, 50%할인가로 만나보세요!</p>
                <p className={styles.description}>딸기는 지금이 제일 맛있어요, 50% 할인가로 만나보세요!</p>
              </div>
              <div className={styles.rowAction}>
                <Button type="primary" size="large" onClick={(e) => moveToLink(e)}>구경하기</Button>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </>
  )
}